var checkoutContainer = null;
var checkoutInitInterval;

export const initCheckout = () => {
    if (document.body.classList.contains("woocommerce-checkout")) {
        setTimeout(function () {
            changeCheckoutWording();
            //moveCouponSection();
        }, 500);
        checkoutInitInterval = setInterval(function () {
            checkInitCheckoutModifiers();
        }, 200);
        checkInitCheckoutModifiers();
    }
};

const checkInitCheckoutModifiers = () => {
    checkoutContainer = document.querySelector(
        ".wp-block-woocommerce-checkout",
    );
    if (checkoutContainer !== null) {
        clearInterval(checkoutInitInterval);
        initCheckoutModifiers();
    }
};

const initCheckoutModifiers = () => {
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                if (
                    mutation.target.classList.contains(
                        "wp-block-woocommerce-checkout-order-summary-block",
                    )
                ) {
                    changeCheckoutWording();
                }
            }
        }
    });

    // Start observing the cart container for changes
    if (checkoutContainer) {
        observer.observe(checkoutContainer, { childList: true, subtree: true });
    }
};

function changeCheckoutWording() {
    const couponButton = document.querySelector(
        ".wc-block-components-totals-coupon .wc-block-components-panel__button",
    );

    const createAccount = document.querySelector(
        ".wc-block-checkout__create-account span",
    );
    console.log("couponButton", couponButton);
    if (couponButton) {
        couponButton.childNodes[1].nodeValue = bm_variables.add_coupon_text;
    }

    if (createAccount) {
        createAccount.innerHTML = bm_variables.checkout_create_account;
    }

    document.querySelector(
        ".wc-block-components-checkout-order-summary__title-text",
    ).innerHTML = bm_variables.checkout_summary_title;
}
